import { InputHTMLAttributes } from "react";
import styled from "styled-components";
import { rgba } from "utilities/rgba";

interface IFieldLabel {
  error?: string;
  disabled?: InputHTMLAttributes<HTMLInputElement>["disabled"];
}

export const FieldLabel = styled.div<IFieldLabel>`
  ${({ theme, disabled, error }) => `
    margin-left: 16px;
    margin-bottom: 4px;
    font-size: 12px;
    line-height: 16px;
    ${error && `color: ${theme.palette.accent.red}`};
    ${disabled && `color: ${rgba(theme.palette.text.primary, 0.4)}`};
  `}
`;
